/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Legal_PrefixInputs */

const en_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By continuing, you agree to Glider’s`)
};

const de_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem Fortfahren akzeptieren Sie Gliders`)
};

const pt_br2_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao continuar, você concorda com os`)
};

const tr_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam ederek Glider'ın`)
};

const zh_cn2_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续即表示您同意 Glider 的`)
};

const zh_hk2_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續即表示你同意 Glider 的`)
};

const ko_kr2_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속하면 Glider의`)
};

const ru_ru2_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжая, вы соглашаетесь с`)
};

const es_419_login_page_legal_prefix = /** @type {(inputs: Login_Page_Legal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al continuar, aceptas los`)
};

/**
* | output |
* | --- |
* | "By continuing, you agree to Glider’s" |
*
* @param {Login_Page_Legal_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_legal_prefix = /** @type {((inputs?: Login_Page_Legal_PrefixInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Legal_PrefixInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_legal_prefix(inputs)
	if (locale === "de") return de_login_page_legal_prefix(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_legal_prefix(inputs)
	if (locale === "tr") return tr_login_page_legal_prefix(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_legal_prefix(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_legal_prefix(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_legal_prefix(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_legal_prefix(inputs)
	return es_419_login_page_legal_prefix(inputs)
});